import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandMark from '../../BrandMark/BrandMark';
import GlassSurface from '../../effects/GlassSurface/GlassSurface';
import PillLink from '../../ui/PillLink/PillLink';
import LanguageSelect from '../LanguageSelect/LanguageSelect';
import MobileMenu from '../MobileMenu/MobileMenu';
import { CONTACT_PATH, primaryNavigation } from '../../../data/navigation';
import { useScrolledPast } from '../../../hooks/useScrolledPast';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './SiteNav.module.css';

const COLLAPSE_OFFSET = 48;

export default function SiteNav() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();
    const isCollapsed = useScrolledPast(COLLAPSE_OFFSET);

    return (
        <header className={styles.header} data-collapsed={isCollapsed} data-theme="dark">
            <div className={styles.shell}>
                <GlassSurface className={styles.glass} />
                <div className={styles.bar}>
                    <Link to={localizedPath('/')} className={styles.home} aria-label={t('a11y.homeLink')}>
                        <BrandMark variant="signet" className={styles.signet} />
                        <span className={styles.wordmarkClip}>
                            <BrandMark variant="wordmark" className={styles.wordmark} />
                        </span>
                    </Link>

                    <nav className={styles.nav} aria-label={t('a11y.primaryNav')}>
                        <ul className={styles.links}>
                            {primaryNavigation.map((item) => (
                                <li key={item.path}>
                                    <Link to={localizedPath(item.path)} className={styles.link}>
                                        {t(item.labelKey)}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div className={styles.actions}>
                        <span className={styles.language}>
                            <LanguageSelect />
                        </span>
                        <PillLink href={localizedPath(CONTACT_PATH)} size="small" className={styles.cta}>
                            {t('nav.cta')}
                        </PillLink>
                        <MobileMenu />
                    </div>
                </div>
            </div>
        </header>
    );
}
